import { Amplify } from "aws-amplify";

const userPoolId = import.meta.env.VITE_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_USER_POOL_CLIENT_ID;

if (userPoolId && userPoolClientId) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: { email: true },
      },
    },
  });
}

export const apiUrl = (import.meta.env.VITE_API_URL || "").replace(/\/$/, "");
export const stage = import.meta.env.VITE_STAGE || "local";
